import React, { useState } from 'react';
import { convocatorias } from '../../json/convocatorias';
import './convocatorias.css';

const ConvocatoriasNew = () => {
  // Agrupar convocatorias por año
  const agruparPorAño = () => {
    const agrupadas = {};
    
    convocatorias.forEach(convocatoria => {
      const año = convocatoria.año || new Date().getFullYear();
      
      if (!agrupadas[año]) {
        agrupadas[año] = [];
      }
      
      agrupadas[año].push(convocatoria);
    });
    
    return agrupadas;
  };

  const convocatoriasPorAño = agruparPorAño();
  const años = Object.keys(convocatoriasPorAño).sort((a, b) => b - a);
  
  // Estado para controlar qué años están expandidos
  // 2026 expandido, 2025 colapsado por defecto
  const [añosExpandidos, setAñosExpandidos] = useState(() => {
    const estadoInicial = {};
    
    años.forEach(año => {
      if (año === "2026") {
        estadoInicial[año] = true; // 2026 expandido
      } else {
        estadoInicial[año] = false; // Todos los demás colapsados
      }
    });
    
    return estadoInicial;
  });

  const toggleAño = (año) => {
    setAñosExpandidos(prev => ({
      ...prev,
      [año]: !prev[año]
    }));
  };

  const expandirTodo = () => {
    const todosExpandidos = {};
    años.forEach(año => {
      todosExpandidos[año] = true;
    });
    setAñosExpandidos(todosExpandidos);
  };

  const colapsarTodo = () => {
    const todosColapsados = {};
    años.forEach(año => {
      todosColapsados[año] = false;
    });
    setAñosExpandidos(todosColapsados);
  };

  // Función para expandir solo el año específico
  const expandirSoloAño = (añoExpandir) => {
    const nuevoEstado = {};
    años.forEach(año => {
      nuevoEstado[año] = (año === añoExpandir); // Solo true para el año especificado
    });
    setAñosExpandidos(nuevoEstado);
  };

  return (
    <div className="pagina-convocatorias">
      <header className="encabezado-pagina">
        <h1 className="titulo-pagina">Catálogo de convocatorias</h1>
        <p className="subtitulo-pagina">Descubre las oportunidades para artistas y creadores en Hidalgo</p>
        
        <div className="controles-años">
          <button onClick={expandirTodo} className="btn-control-año">
            Expandir todos los años
          </button>
          <button onClick={colapsarTodo} className="btn-control-año">
            Colapsar todos los años
          </button>
          <button 
            onClick={() => expandirSoloAño("2026")} 
            className="btn-control-año btn-especial"
          >
            Ver solo 2026
          </button>
          <button 
            onClick={() => expandirSoloAño("2025")} 
            className="btn-control-año btn-especial"
          >
            Ver solo 2025
          </button>
        </div>
      </header>
      
      <main className="contenedor-convocatorias">
        {años.map(año => (
          <section key={año} className="seccion-año">
            <div 
              className="encabezado-año"
              onClick={() => toggleAño(año)}
            >
              <h2 className="titulo-año">
                Convocatorias {año}
                <span className="contador-convocatorias">
                  ({convocatoriasPorAño[año].length})
                </span>
                {!añosExpandidos[año] && (
                  <span className="badge-colapsado">(Colapsado)</span>
                )}
              </h2>
              <div className="icono-expandir">
                {añosExpandidos[año] ? '−' : '+'}
              </div>
            </div>
            
            {añosExpandidos[año] && (
              <div className="contenido-año">
                <div className="grid-convocatorias">
                  {convocatoriasPorAño[año].map((convocatoria, index) => (
                    <div key={index} className='tarjeta-convocatoria'>
                      <a href={convocatoria.url} target="_blank" rel="noopener noreferrer" className="enlace-convocatoria">
                        <div 
                          className="imagen-convocatoria" 
                          style={{ backgroundImage: `url('${convocatoria.imagen}')` }}
                        >
                          <div className='fecha-superior'>
                            <span className='icono-calendario'></span> {convocatoria.año}
                          </div>
                          
                          <div className='overlay'></div>
                          
                          <div className='contenido-texto'>
                            <h3 className='titulo-convocatoria'>{convocatoria.titulo}</h3>
                            <div className={`badge-urgente ${convocatoria.estado === "CONVOCATORIA CERRADA" ? "cerrada" : convocatoria.estado === "CONVOCATORIA ABIERTA" ? "abierta" : "resultados"}`}>
                              {convocatoria.estado}
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </section>
        ))}
      </main>
    </div>
  );
};

export default ConvocatoriasNew;